import React, { useEffect } from "react";
import { FUXA_URL } from "../../constant";

const ZOOM = 0.75; // adjust this value

const FuxaView = () => {
	const scale = ZOOM;
	const inverse = `${(1 / scale) * 100}%`;

	useEffect(() => {
		document.body.classList.add("fuxa-page");
		return () => {
			document.body.classList.remove("fuxa-page");
		};
	}, []);

	return (
		<div
			style={{
				position: "fixed",
				top: 50,
				left: 0,
				right: 0,
				bottom: 0,
				overflow: "hidden",
			}}
		>
			<iframe
				src={FUXA_URL}
				style={{
					width: inverse,
					height: inverse,
					border: "none",
					display: "block",
					transform: `scale(${scale})`,
					transformOrigin: "top left",
				}}
				title="FUXA Main View"
			/>
		</div>
	);
};

export default FuxaView;
